import { IApplicationState } from '../../../../../../types/types';

export const getHighlightedMentionIndex = (state: IApplicationState) => {
    return state.comments.highlightedMention;
}
